"use client"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import Bottom from "@fuse/sharedComponents/legacyUI/Bottom"
import Navbar from "@fuse/sharedComponents/navbar/Navbar"

export default function EventError() {
  return (
    <div
      style={{
        background: `url(/assets/alpha-event-not-found.svg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="flex flex-col min-h-screen  "
    >
      <BlurWrapper
        className="flex flex-col flex-1"
        overlayOpacityDefault="10"
        overlayColorDefault="dark"
      >
        <Navbar />
        <ErrorState />
        <div className="mt-auto">
          <Bottom />
        </div>
      </BlurWrapper>
    </div>
  )
}

export function ErrorState() {
  return (
    <div className="h-full flex-1 my-auto w-full flex bg-transparent items-center justify-center p-4">
      <div className=" w-full p-[20px]  md:p-[56px]">
        <div className="flex flex-col items-center text-center">
          <div className="text-6xl">
            {" "}
            <img
              src="/assets/event-error.png"
              alt="emoji"
              className="w-[450px] mx-auto"
            />
          </div>
          <h1 className="text-[32px] font-semibold mt-[32px] text-white">
            Something went wrong
          </h1>

          <p className="text-gray-300 font-[400] text-[16px] md:text-[24px] px-[30px] mt-[24px]">
            Oops! It seems there was an issue. <br /> Please refresh the page
            and try again.
          </p>

          <button
            onClick={() => {
              window.location.reload()
            }}
            className="px-[66px] mt-[56px] py-[18px] bg-gray-600 rounded-full hover:bg-gray-60 blurTypeLight border border-white/20 ring-1 ring-gray-900/5 text-white"
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  )
}
